import { nextTick } from "vue";

export const PostAuthHandler = {
    data: function() {
        return {
            routes: {
                "disclaimer": "disclaimer",
                "broadcast": "broadcast",
                "continueSfl": "saveForLater",
                "consentInfo": "consentInfo"
            },
            hasMoreWork: false,
            action: null
        }
    },

    methods: {
        start: function(actions) {
            this.storeNextAction(actions);
            nextTick(function() {
                this.continue();
            }.bind(this));
        },

        continue: function(data) { 
            if (this.hasMoreWork) {
                this.$axios({
                    method: this.action.type,
                    url: this.action.href,
                    data: data
                }).then(function(response) {
                    if (response.data.status === "POSTAUTH_COMPLETED") {
                        this.goToPortfolio();
                    }
                    else if (response.data.status === "POSTAUTH_INIT") {
                        this.storeNextAction(response.data.links);
                        nextTick(function() {
                            this.continue();
                        }.bind(this));
                    }
                    else {
                        this.storeNextAction(response.data.links);
                        var consentOptions = {};
                        if(response.data.status === "POSTAUTH_PENDING" && this.action.name === "consentInfo") {
                            consentOptions = {
                                isPreAuth: true,
                                responseData: response.data.data[0]
                            };
                        }
                        nextTick(function() {
                            this.navigatePostAuth(response.data, consentOptions);
                        }.bind(this));
                    }
                }.bind(this));
            }
            else {
                this.goToPortfolio();
            }
        },

        storeNextAction: function(actions) {
            if (actions !== undefined && actions.next !== undefined) {
                this.action = actions.next;
            }
            else {
                this.action = null;
            }
        },

        navigatePostAuth: function(data, additionalData) {
            var postAuthData = {
                data: data.data,
                links: data.links,
                hasMoreWork: this.hasMoreWork,
                action: this.action,
                ...additionalData
            };
            this.$emitter.emit('navigate', {
                componentName: this.getRoute(),
                routeData: postAuthData
            });
        },

        getRoute: function() {
            return this.routes[this.action.name];
        },

    goToPortfolio: function () {
      const params = new URLSearchParams(window.location.search);

      let path = "viewportfolio";
      const requested = params.get("do");

      if (requested && typeof requested === "string") {
        const normalized = requested.trim();

        // Prevent paths that include schemes or protocol-relative URLs.
        // Allow only relative internal paths / identifiers with safe chars.
        const safePathPattern = /^[a-zA-Z0-9_\-\/]*$/;
        if (!normalized.startsWith("//") && safePathPattern.test(normalized) && normalized.length > 0) {
          path = normalized;
        }
      }

      params.delete("do");
      const query = params.toString();

      const targetUrl = query ? `${path}?${query}` : path;
      window.location.href = targetUrl;
    },
  },

    watch: {
        action: function(val) {
            if (val !== null) {
                this.hasMoreWork = true;
            }
            else {
                this.hasMoreWork = false;
            }
        }
    }
}